import { ItemDaTabelaDePreco } from '@/models';
import {Inject} from "inversify-props";
import type { TabelaDePrecoServiceAdapter } from '@/usecases';

export class UpdateItemUseCase {
	@Inject('TabelaDePrecoServiceAdapter')
	private tabelaService!: TabelaDePrecoServiceAdapter

	async execute(idTabela: string, item: ItemDaTabelaDePreco): Promise<ItemDaTabelaDePreco> {
		return this.tabelaService.alteraItem(idTabela, item)
	}

	async updateProdutoPai(idTabela: string, item: ItemDaTabelaDePreco, skuProdutoPai: string): Promise<ItemDaTabelaDePreco> {
		return this.tabelaService.updateProdutoPai(idTabela, item, skuProdutoPai)
	}

}
